export default function lookbackWeightingNote(term, dateLabel) {
  const numericTerm = parseFloat(term);
  if (!Number.isFinite(numericTerm) || numericTerm <= 0) return '';
  const termLabel = Math.abs(numericTerm - Math.round(numericTerm)) < 0.001
    ? numericTerm.toFixed(1)
    : numericTerm.toFixed(2);
  return `Weighted equity volatility defaults to the ${dateLabel} term of ${termLabel} years: the matching lookback when the term equals a column, otherwise linear interpolation between the adjacent annual lookbacks. Columns are ±2 years around that term.`;
}
